import React, { Fragment, useEffect, useState } from 'react'
import classnames from 'classnames'
import { object, func, bool } from 'prop-types'
import { hasValue } from '../../../services/util/CommonUtil'
import Skeleton from '../../../components/library/loaders/Skeleton'
import EmdashText from '../../../components/library/common/EmdashText'
import { ChevronRight } from '@mui/icons-material'
import HrbTranslate from '../../../components/language/HrbTranslate'
import AssociateAutoAssignProducts from './AssociateAutoAssignProducts'

const AssociatesSelectorRow = ({ associate, hasError, onRteAssignableToggle, onManageClick, isSaving }) => {

    const handleManageClick = e => {
        e.preventDefault()
        e.stopPropagation();

        if (onManageClick) {
            onManageClick(associate)
        }
    }

    return (<div className='columns'>
        {associate ?
            <Fragment>
                <div className='associate-row column is-10 is-offset-1 columns is-multiline px-0 my-0 py-1 level div-hover' onClick={handleManageClick}>
                    <div className='column is-3 pl-0 level-item'>{hasValue(associate.id) ? `${associate.firstName} ${associate.lastName}` : <EmdashText />}</div>
                    <div className='column is-4 pl-0 level-item'>{hasValue(associate.jobTitle) ? associate.jobTitle : <EmdashText />}</div>
                    <div className='column is-4 level-item is-centered'>
                        <AssociateAutoAssignProducts associate={associate} />
                    </div>
                    <div className='column is-1 level-item'>
                        <div id={`${associate.id}-manage-offices`}
                            className={classnames('a chevron is-pulled-right')}
                            onClick={e => handleManageClick(e)}>
                            <ChevronRight />
                        </div>
                    </div>
                    {hasError &&
                        <div className='column is-12 px-0 pt-0'>
                            <HrbTranslate text='AssociatesPage.AssignmentError' className='p2 error-text' />
                        </div>
                    }
                </div>
            </Fragment>
            :
            <div className='associate-row column is-10 is-offset-1 columns px-0 my-0 py-1'>
                <div className='column is-4 pl-0 level-item'><Skeleton width='175px' /></div>
                <div className='column is-4 pl-0 level-item'><Skeleton width='85px' /></div>
                <div className='column is-3 pl-0 level-item'><Skeleton width='55px' /></div>
                <div className='column is-1 level-item'></div>
            </div>
        }
    </div>)
}

AssociatesSelectorRow.propTypes = {
    associate: object,
    onManageClick: func
}

export default AssociatesSelectorRow